export async function fetchLeaderboard({ token, sessionId, organizationId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/fetchLeaderboard`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      sessionId,
      organizationId,
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || 'Failed to fetch leaderboard');
  }
  if (data && data.success === false) {
    throw new Error(data.message || 'Failed to fetch leaderboard');
  }
  return data.data || [];
}
